import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export function getQueryKey(credentialRequestId?: string) {
  return credentialRequestId === undefined
    ? ["tokens", "credentialRequests"]
    : ["tokens", "credentialRequests", credentialRequestId];
}

/**
 * Read a pending credential request for approval without query-level retries.
 *
 * Reuse the pending review while mounted. Explicit refetches or invalidation can return unavailable
 * after a decision; the page preserves its decision outcome.
 */
export function useCredentialRequest(credentialRequestId: string) {
  const { credentialRequestService } = useDomainServices();

  return useQuery({
    queryKey: getQueryKey(credentialRequestId),
    queryFn: ({ signal }) =>
      credentialRequestService.getPending(credentialRequestId, {
        abortSignal: signal,
      }),
    retry: false,
    staleTime: Infinity,
  });
}
